module.exports = __webpack_public_path__ + "img/crane-truck.4296a9dc.svg";